// Transporte das actions `pessoa_*` (ciclo da pessoa: login + ficha +
// organograma, comercial-engine handlers/pessoaCiclo.js). Mesma rota e mesmo
// desembrulho do body das outras actions do comercial.
import axios from 'axios';
import { API_URL } from '../../config';
import { getToken } from '../../utils/auth';

export type Setor = { id: string; nome: string; ativo: boolean; ordem: number };
export type ChefeOpcao = { id: string; nome: string; usuario_email: string | null; setor: string | null };
export type PerfilOpcao = { codigo: string; nome: string; descricao?: string | null; possui_permissao_nexo: boolean };
export type Opcoes = {
  pode_ciclo: boolean;
  pode_salario: boolean;
  setores: Setor[];
  chefes: ChefeOpcao[];
  perfis: PerfilOpcao[];
  tipos_vinculo: string[];
  hoje: string;
};

export type Conferencia = {
  logins_sem_ficha: Array<{ email: string; nome: string; enabled: boolean; criado_em: string | null }>;
  contas_sem_vinculo: Array<{ usuario_email: string; motivo: string | null; marcado_por: string | null; marcado_em: string }>;
  fichas_sem_login: Array<{ profissional_id: string; nome: string; setor: string | null }>;
  login_sumiu: Array<{ profissional_id: string; nome: string; usuario_email: string }>;
  login_bloqueado: Array<{ profissional_id: string; nome: string; usuario_email: string }>;
  flag_divergente: Array<{ profissional_id: string; nome: string; desligamento: string | null }>;
  inativas_sem_data: Array<{ profissional_id: string; nome: string; usuario_email: string | null }>;
  horas_sem_ficha: Array<{ usuario_email: string; lancamentos: number; de: string; ate: string }>;
  organograma: Array<{ profissional_id: string; nome: string; usuario_email: string | null; setor: string | null; chefe_nome: string | null; pendencias: string[] }>;
  total_pendencias: number;
};

/** Erro de action com o corpo que o servidor mandou (codigo, candidatas…). */
export class ErroPessoa extends Error {
  status: number;
  dados: any;
  constructor(status: number, dados: any) {
    super(dados?.error || dados?.erro || `Erro ${status}`);
    this.status = status;
    this.dados = dados || {};
  }
}

export async function acaoPessoa<T = any>(action: string, body: Record<string, any> = {}): Promise<T> {
  const token = await getToken();
  try {
    const r = await axios.post(`${API_URL}/comercial/propostas-geradas`,
      { action, ...body }, { headers: { Authorization: token } });
    return r.data.body ? JSON.parse(r.data.body) : r.data;
  } catch (e: any) {
    const status = e?.response?.status || 0;
    let dados = e?.response?.data;
    if (dados && typeof dados.body === 'string') { try { dados = JSON.parse(dados.body); } catch { /* fica cru */ } }
    if (!status) throw e;
    throw new ErroPessoa(status, dados);
  }
}

export const NOME_PENDENCIA: Record<string, string> = {
  sem_login: 'sem login no sistema',
  sem_chefe: 'sem chefe direto',
  sem_setor: 'sem setor',
  sem_admissao: 'sem data de admissão',
  sem_remuneracao_vigente: 'sem remuneração vigente (horas sem custo)',
  chefe_inativo: 'chefe direto já saiu da empresa',
  ativo_com_saida_passada: 'ativo com data de saída no passado',
  inativa_sem_data: 'inativa sem data de saída',
};

export const fmtData = (iso: string | null | undefined): string =>
  iso ? `${String(iso).slice(8, 10)}/${String(iso).slice(5, 7)}/${String(iso).slice(0, 4)}` : '—';
